import { BrandTypes } from '@ps/platform-message-framework/common/BrandTypes';
import { FeatureFlag } from '@ps/web-core-enums';
import { select, useFeature } from '@ps/web-core-store';
import { ThemeProvider } from '@ps/web-fusion-components';
import React from 'react';
import { useSelector } from 'react-redux';

import type { WidgetFC } from '@swf/core/types/Widget';
import { CommonStylesProvider, initModuleNativeClient } from '@swf/poker';

import PowerPath from './components/PowerPath/PowerPath';
import SpadePowerPath from './components/SpadePowerPath/SpadePowerPath';
import { pokerPowerPathWidgetModel } from './model';

// This is needed to enable spinandgo functionality in desktop client, so to be able to launch step1 game
initModuleNativeClient('spinandgo');

const PokerPowerPathWidget: WidgetFC = () => {
  const isPowerPathEmbedded = useFeature(FeatureFlag.SpadeReleaseEmbedPowerPath);
  const brandId = useSelector(select.cms.getBrandId);
  const isSisalBrand = brandId === BrandTypes.SISAL;

  if (isPowerPathEmbedded) {
    return <SpadePowerPath />;
  }

  return (
    <ThemeProvider theme={isSisalBrand ? 'sisal' : 'ps-dark'}>
      <CommonStylesProvider>
        <PowerPath />
      </CommonStylesProvider>
    </ThemeProvider>
  );
};

PokerPowerPathWidget.model = pokerPowerPathWidgetModel;

export default PokerPowerPathWidget;
